export const ageMethod = "age nearest";
export const gateway = "https://western-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/western";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ3ZXN0ZXJuIiwibmFtZSI6Indlc3Rlcm4iLCJpYXQiOjE3Nzk5MjY4NzYsImV4cCI6MTkzNzcxNDg3Nn0.jLGH7bmX4JmtikGV2bXNLRqKiHl33X27kPP3VJ2AuTA";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"western.link.wawanesalife.com": {
		a: {
			accessibilityLink: "https://westernfinancialgroup.ca/Accessibility-Guidelines",
			approve_company: "Western Financial Group (Network) Inc.",
			approve_user: "link_western",
			brands: [
				"western.link.wawanesalife.com",
			],
			broker: "western",
			broker_formatted_name: "Western Financial Group",
			email: "myinsurancenow@westernfg.ca",
			environment: "stable",
			environment_id: "stable",
			ftcLink: "https://westernfinancialgroup.ca/Customers-Fair-Treatment",
			g4: "G-2QM64W4BM4",
			layout: "flat",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "(888) 594-3105",
			privacyLink: "https://westernfinancialgroup.ca/Privacy",
			themeSwitcher: "hide",
			video_link: "dOPJxsVASJA",
			website: "https://westernfinancialgroup.ca/",
			scope: "western#branding#western.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "western.link.wawanesalife.com",
		},
		b: {
			accessibilityLink: "https://westernfinancialgroup.ca/Accessibility-Guidelines",
			approve_company: "Western Financial Group (Network) Inc.",
			approve_user: "link_western",
			brands: [
				"western.link.wawanesalife.com",
			],
			broker: "western",
			broker_formatted_name: "Western Financial Group",
			email: "myinsurancenow@westernfg.ca",
			environment: "stable",
			environment_id: "stable",
			ftcLink: "https://westernfinancialgroup.ca/Customers-Fair-Treatment",
			g4: "G-2QM64W4BM4",
			layout: "flat",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "(888) 594-3105",
			privacyLink: "https://westernfinancialgroup.ca/Privacy",
			themeSwitcher: "hide",
			video_link: "dOPJxsVASJA",
			website: "https://westernfinancialgroup.ca/",
			scope: "western#branding#western.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "western.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 19:07:56 GMT-0500 (Central Daylight Time)
